import actionTypes from './actionTypes';

const INITIAL_STATE = {
  menuCategoriesLoading: false,
  menuCategoriesFailed: false,
  menuCategoriesError: false,
  menuCategoriesMessage: null,
  menuCategories: {},
  menuCategoriesList: [],

  changeMenuCategoryStatusLoading: false,
  changeMenuCategoryStatusFailed: false,
  changeMenuCategoryStatusError: false,
  changeMenuCategoryStatusMessage: null,

  deletedMenuCategoriesLoading: false,
  deletedMenuCategoriesFailed: false,
  deletedMenuCategoriesError: false,
  deletedMenuCategoriesMessage: null,
  deletedMenuCategories: {},
  deletedMenuCategoriesList: [],

  menuCategoryDetailsLoading: false,
  menuCategoryDetailsFailed: false,
  menuCategoryDetailsError: false,
  menuCategoryDetailsMessage: null,
  menuCategoryDetails: {},

  deleteMenuCategoryLoading: false,
  deleteMenuCategoryFailed: false,
  deleteMenuCategoryError: false,
  deleteMenuCategoryMessage: null,

  insertNewMenuCategoryLoading: false,
  insertNewMenuCategoryFailed: false,
  insertNewMenuCategoryError: false,
  insertNewMenuCategoryMessage: null,

  editMenuCategoryLoading: false,
  editMenuCategoryFailed: false,
  editMenuCategoryError: false,
  editMenuCategoryMessage: null,

  fetchPrintersLoading: false,
  fetchPrintersFailed: false,
  fetchPrintersError: false,
  fetchPrintersMessage: null,
  printersList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_MENU_CATEGORIES_LOADING: {
      return {
        ...state,
        menuCategoriesLoading: true,
        menuCategoriesFailed: false,
        menuCategoriesError: false,
        menuCategoriesMessage: null,
        menuCategoriesList: [],
        menuCategories: {},
      };
    }
    case actionTypes.FETCH_ALL_MENU_CATEGORIES_SUCCESS: {
      return {
        ...state,
        menuCategoriesLoading: false,
        menuCategoriesFailed: false,
        menuCategoriesError: false,
        menuCategoriesMessage: null,
        menuCategories: { ...action.payload },
        menuCategoriesList: [...action.payload.menuCategories],
      };
    }
    case actionTypes.FETCH_ALL_MENU_CATEGORIES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        menuCategoriesLoading: false,
        menuCategoriesFailed: true,
        menuCategoriesError: false,
        menuCategoriesMessage: message,
        menuCategoriesList: [],
        menuCategories: {},
      };
    }
    case actionTypes.FETCH_ALL_MENU_CATEGORIES_REJECT: {
      return {
        ...state,
        menuCategoriesLoading: false,
        menuCategoriesFailed: false,
        menuCategoriesError: true,
        menuCategoriesMessage: null,
        menuCategoriesList: [],
        menuCategories: {},
      };
    }

    case actionTypes.CHANGE_MENU_CATEGORY_STATUS_LOADING: {
      return {
        ...state,
        changeMenuCategoryStatusLoading: true,
        changeMenuCategoryStatusFailed: false,
        changeMenuCategoryStatusError: false,
        changeMenuCategoryStatusMessage: null,
      };
    }
    case actionTypes.CHANGE_MENU_CATEGORY_STATUS_SUCCESS: {
      return {
        ...state,
        changeMenuCategoryStatusLoading: false,
        changeMenuCategoryStatusFailed: false,
        changeMenuCategoryStatusError: false,
        changeMenuCategoryStatusMessage: null,
      };
    }
    case actionTypes.CHANGE_MENU_CATEGORY_STATUS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        changeMenuCategoryStatusLoading: false,
        changeMenuCategoryStatusFailed: true,
        changeMenuCategoryStatusError: false,
        changeMenuCategoryStatusMessage: message,
      };
    }
    case actionTypes.CHANGE_MENU_CATEGORY_STATUS_REJECT: {
      return {
        ...state,
        changeMenuCategoryStatusLoading: false,
        changeMenuCategoryStatusFailed: false,
        changeMenuCategoryStatusError: true,
        changeMenuCategoryStatusMessage: null,
      };
    }

    case actionTypes.DELETE_MENU_CATEGORY_LOADING: {
      return {
        ...state,
        deleteMenuCategoryLoading: true,
        deleteMenuCategoryFailed: false,
        deleteMenuCategoryError: false,
        deleteMenuCategoryMessage: null,
      };
    }
    case actionTypes.DELETE_MENU_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteMenuCategoryLoading: false,
        deleteMenuCategoryFailed: false,
        deleteMenuCategoryError: false,
        deleteMenuCategoryMessage: null,
      };
    }
    case actionTypes.DELETE_MENU_CATEGORY_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deleteMenuCategoryLoading: false,
        deleteMenuCategoryFailed: true,
        deleteMenuCategoryError: false,
        deleteMenuCategoryMessage: message,
      };
    }
    case actionTypes.DELETE_MENU_CATEGORY_REJECT: {
      return {
        ...state,
        deleteMenuCategoryLoading: false,
        deleteMenuCategoryFailed: false,
        deleteMenuCategoryError: true,
        deleteMenuCategoryMessage: null,
      };
    }

    case actionTypes.FETCH_MENU_CATEGORY_BY_ID_LOADING: {
      return {
        ...state,
        menuCategoryDetailsLoading: true,
        menuCategoryDetailsFailed: false,
        menuCategoryDetailsError: false,
        menuCategoryDetailsMessage: null,
        menuCategoryDetails: {},
      };
    }
    case actionTypes.FETCH_MENU_CATEGORY_BY_ID_SUCCESS: {
      return {
        ...state,
        menuCategoryDetailsLoading: false,
        menuCategoryDetailsFailed: false,
        menuCategoryDetailsError: false,
        menuCategoryDetailsMessage: null,
        menuCategoryDetails: action.payload,
      };
    }
    case actionTypes.FETCH_MENU_CATEGORY_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        menuCategoryDetailsLoading: false,
        menuCategoryDetailsFailed: true,
        menuCategoryDetailsError: false,
        menuCategoryDetails: {},
        menuCategoryDetailsMessage: message,
      };
    }
    case actionTypes.FETCH_MENU_CATEGORY_BY_ID_REJECT: {
      return {
        ...state,
        menuCategoryDetailsLoading: false,
        menuCategoryDetailsFailed: false,
        menuCategoryDetailsError: true,
        menuCategoryDetails: {},
        menuCategoryDetailsMessage: null,
      };
    }

    case actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_LOADING: {
      return {
        ...state,
        deletedMenuCategoriesLoading: true,
        deletedMenuCategoriesFailed: false,
        deletedMenuCategoriesError: false,
        deletedMenuCategoriesMessage: null,
        deletedMenuCategoriesList: [],
        deletedMenuCategories: {},
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_SUCCESS: {
      return {
        ...state,
        deletedMenuCategoriesLoading: false,
        deletedMenuCategoriesFailed: false,
        deletedMenuCategoriesError: false,
        deletedMenuCategoriesMessage: null,
        deletedMenuCategories: { ...action.payload },
        deletedMenuCategoriesList: [...action.payload.menuCategories],
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deletedMenuCategoriesLoading: false,
        deletedMenuCategoriesFailed: true,
        deletedMenuCategoriesError: false,
        deletedMenuCategoriesMessage: message,
        deleteMenuCategoriesList: [],
        deletedMenuCategories: {},
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_REJECT: {
      return {
        ...state,
        deletedMenuCategoriesLoading: false,
        deletedMenuCategoriesFailed: false,
        deletedMenuCategoriesError: true,
        deletedMenuCategoriesMessage: null,
        menuCategoriesList: [],
        deletedMenuCategories: {},
      };
    }

    case actionTypes.INSERT_NEW_MENU_CATEGORY_LOADING: {
      return {
        ...state,
        insertNewMenuCategoryLoading: true,
        insertNewMenuCategoryFailed: false,
        insertNewMenuCategoryError: false,
        insertNewMenuCategoryMessage: null,
      };
    }
    case actionTypes.INSERT_NEW_MENU_CATEGORY_SUCCESS: {
      return {
        ...state,
        insertNewMenuCategoryLoading: false,
        insertNewMenuCategoryFailed: false,
        insertNewMenuCategoryError: false,
        insertNewMenuCategoryMessage: null,
      };
    }
    case actionTypes.INSERT_NEW_MENU_CATEGORY_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        insertNewMenuCategoryLoading: false,
        insertNewMenuCategoryFailed: true,
        insertNewMenuCategoryError: false,
        insertNewMenuCategoryMessage: message,
      };
    }
    case actionTypes.INSERT_NEW_MENU_CATEGORY_REJECT: {
      return {
        ...state,
        insertNewMenuCategoryLoading: false,
        insertNewMenuCategoryFailed: false,
        insertNewMenuCategoryError: true,
        insertNewMenuCategoryMessage: null,
      };
    }

    case actionTypes.EDIT_MENU_CATEGORY_LOADING: {
      return {
        ...state,
        editMenuCategoryLoading: true,
        editMenuCategoryFailed: false,
        editMenuCategoryError: false,
        editMenuCategoryMessage: null,
      };
    }
    case actionTypes.EDIT_MENU_CATEGORY_SUCCESS: {
      return {
        ...state,
        editMenuCategoryLoading: false,
        editMenuCategoryFailed: false,
        editMenuCategoryError: false,
        editMenuCategoryMessage: null,
      };
    }
    case actionTypes.EDIT_MENU_CATEGORY_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        editMenuCategoryLoading: false,
        editMenuCategoryFailed: true,
        editMenuCategoryError: false,
        editMenuCategoryMessage: message,
      };
    }
    case actionTypes.EDIT_MENU_CATEGORY_REJECT: {
      return {
        ...state,
        editMenuCategoryLoading: false,
        editMenuCategoryFailed: false,
        editMenuCategoryError: true,
        editMenuCategoryMessage: null,
      };
    }
    case actionTypes.FETCH_PRINTERS_LOADING: {
      return {
        ...state,
        fetchPrintersLoading: true,
        fetchPrintersFailed: false,
        fetchPrintersError: false,
        fetchPrintersMessage: null,
        printersList: [],
      };
    }
    case actionTypes.FETCH_PRINTERS_SUCCESS: {
      return {
        ...state,
        fetchPrintersLoading: false,
        fetchPrintersFailed: false,
        fetchPrintersError: false,
        fetchPrintersMessage: null,
        printersList: action.payload.printers,
      };
    }
    case actionTypes.FETCH_PRINTERS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        fetchPrintersLoading: false,
        fetchPrintersFailed: true,
        fetchPrintersError: false,
        fetchPrintersMessage: message,
        printersList: [],
      };
    }
    case actionTypes.FETCH_PRINTERS_REJECT: {
      return {
        ...state,
        fetchPrintersLoading: false,
        fetchPrintersFailed: false,
        fetchPrintersError: true,
        fetchPrintersMessage: null,
        printersList: [],
      };
    }
    default:
      return state;
  }
};
